import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { PaymentMethodResponseV1Dto } from '@frontend';

@Component({
  selector: 'app-google-pay',
  imports: [GooglePayButtonModule],
  templateUrl: './google-pay.component.html',
  styleUrl: './google-pay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GooglePayComponent implements OnInit {
  @Input({ required: true }) paymentMethod: PaymentMethodResponseV1Dto;
  @Input({ required: true }) amount: string;
  @Input({ required: true }) currencyCode: string;

  @Output() paymentResult = new EventEmitter<{
    cardToken: string;
    paymentProduct: string;
  }>();
  paymentRequest: google.payments.api.PaymentDataRequest;

  ngOnInit() {
    this.paymentRequest = {
      ...this.paymentMethod.config.config.google,
      transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPrice: this.amount,
        currencyCode: this.currencyCode
      }
    };
  }

  loadPaymentData(event: google.payments.api.PaymentData) {
    this.paymentResult.emit({
      cardToken: event.paymentMethodData.tokenizationData.token,
      paymentProduct: event.paymentMethodData.info.cardNetwork
    });
  }
}
